// ProtectedRoute.tsx
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { EPermission } from '@/enums/EPermission';
import { EUserRole } from '@/enums/EUserRole';

interface ProtectedRouteProps {
  element: React.ReactElement;
  permissions: string[];
  roles?: EUserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  permissions,
  roles,
}) => {
  const { isAuthenticated, userInfo } = useAuth();
  const hasPermission = userInfo?.permissions?.some(permission =>
    permissions.includes(permission),
  );

  const hasRoleAccess = roles && roles.includes(userInfo?.role as EUserRole);
  if (
    (!hasPermission && permissions.some(c => c !== EPermission.Allow)) ||
    (!hasRoleAccess && !!roles)
  ) {
    return <Navigate to="/404" />;
  }
  return isAuthenticated ? element : <Navigate to="/login" />;
};

export default ProtectedRoute;
